// src/components/CampaignCreationPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const CampaignCreationPage = () => {
  const navigate = useNavigate();

  const [pitch, setPitch] = useState("");
  const [roadmap, setRoadmap] = useState("");
  const [media, setMedia] = useState(null);

  const handleNext = () => {
    if (!pitch || !roadmap) {
      alert("Please provide a pitch and a roadmap.");
      return;
    }
    console.log("{ pitch, roadmap, media }", { pitch, roadmap, media });
    
    navigate("/token-sale");
  };

  return (
    <div className="campaign-creation">
      <h2>Create Your Campaign</h2>
      <div className="form-group">
        <p className="form-label">Project Pitch</p>
        <textarea
          value={pitch}
          onChange={(e) => setPitch(e.target.value)}
        ></textarea>
      </div>
      <div className="form-group">
        <p className="form-label">Roadmap</p>
        <textarea
          placeholder="e.g., milestones"
          value={roadmap}
          onChange={(e) => setRoadmap(e.target.value)}
        ></textarea>
      </div>
      <div className="form-group">
        <p className="form-label">Media</p>
        <input
          type="file"
          onChange={(e) => setMedia(e.target.files[0])}
        />
      </div>
      <button onClick={handleNext}>Publish Campaign</button>
    </div>
  );
};

export default CampaignCreationPage;
